/**
 * Pneumologie — specialty manifest.
 *
 * Maintained through the Specialty Registry. The manifest is data: the shell
 * reads it and knows nothing about this specialty.
 *
 * Legacy codes resolved here: PNEU
 * Catalogue acts (NGAP Maroc): 142
 */
import { defineSpecialty } from "../types";

export const pneumologie = defineSpecialty(
{
  "id": "pneumologie",
  "label": "Pneumologie",
  "short": "Pneumo.",
  "scope": "Appareil respiratoire",
  "aliases": [
    "PNEU"
  ],
  "doctorSpecs": [
    "Pneumologie"
  ],
  "featureFlag": "ux.v2.pneumologie",
  "theme": {
    "primary": "oklch(0.74 0.14 210)",
    "primaryForeground": "oklch(0.98 0.005 240)",
    "accent": "oklch(0.78 0.16 80)",
    "accentForeground": "oklch(0.18 0.02 240)",
    "destructive": "oklch(0.65 0.22 27)",
    "success": "oklch(0.78 0.18 150)",
    "warning": "oklch(0.78 0.16 80)",
    "surface": "oklch(0.205 0.006 240)",
    "radius": "0.75rem",
    "fontDisplay": "\"Inter\", ui-sans-serif, system-ui, sans-serif"
  },
  "navigation": [
    {
      "id": "consult",
      "label": "Consultation",
      "icon": "Stethoscope",
      "route": "/clinical/consult",
      "order": 1,
      "requires": []
    },
    {
      "id": "spirometry",
      "label": "Spirométrie",
      "icon": "Wind",
      "route": "/clinical/spirometry",
      "order": 2,
      "requires": [
        "pneumo"
      ]
    },
    {
      "id": "imaging",
      "label": "Imagerie",
      "icon": "Image",
      "route": "/clinical/imaging",
      "order": 3,
      "requires": [
        "imaging"
      ]
    },
    {
      "id": "prescription",
      "label": "Ordonnance",
      "icon": "Pill",
      "route": "/clinical/prescription",
      "order": 4,
      "requires": []
    },
    {
      "id": "billing",
      "label": "Cotations",
      "icon": "Receipt",
      "route": "/clinical/billing",
      "order": 5,
      "requires": []
    }
  ],
  "panels": [
    {
      "id": "spirometry",
      "label": "Spirométrie",
      "icon": "Wind",
      "component": "SpirometryPanel",
      "order": 1,
      "requires": []
    },
    {
      "id": "vitals",
      "label": "Constantes",
      "icon": "Gauge",
      "component": "VitalSignsGrid",
      "order": 2,
      "requires": []
    },
    {
      "id": "timeline",
      "label": "Chronologie",
      "icon": "History",
      "component": "PatientTimeline",
      "order": 3,
      "requires": []
    }
  ],
  "ngap": {
    "specialtyScope": "Pneumologie",
    "subSpecialties": [
      "Consultation",
      "Spirométrie",
      "EFR",
      "Bronchoscopie"
    ],
    "catalogueActs": 142
  },
  "terminology": {
    "icd10": [
      "J00",
      "J20",
      "J40",
      "J45",
      "J96"
    ],
    "loinc": [
      "19868-9",
      "20150-9"
    ],
    "snomed": []
  },
  "deviceProfiles": [
    "spirometer",
    "peak-flow",
    "pulse-oximeter"
  ],
  "locales": [
    "fr",
    "ar"
  ]
}
);

export default pneumologie;
